/**
 *
 * @description A utility function that can be used whenever we need to extract
 * data from a post message.
 * @param {MessageEvent} message
 * @returns {object}
 */
export const getParsedDataFromPostMessage = (message) => {
    const { data = "" } = message;
    let parsedDataFromPostMessage = {};
    let threwErrorWhenParsingJSON = false;

    const hasThePotentialToBeValidJSON =
        typeof data === "string" && data !== "recaptcha-setup";

    if (hasThePotentialToBeValidJSON) {
        try {
            parsedDataFromPostMessage = JSON.parse(data);
        } catch {
            threwErrorWhenParsingJSON = true;
        }

        const isObjectWithKeys =
            typeof parsedDataFromPostMessage === "object" &&
            Object.keys(parsedDataFromPostMessage).length > 0;
        const isParsedDataValidJSON =
            !threwErrorWhenParsingJSON && isObjectWithKeys;

        if (isParsedDataValidJSON) {
            return parsedDataFromPostMessage;
        }
    }

    return {};
};
